import AccordionItemPrimary from "../../common/accordion-item/accordion-item-primary/accordion-item-primary";
import { getAssetUrl } from "../../../api/api";
import type { TTenderhubShowreel } from "../../../types/tenderhub";

type Props = {
  showreel?: TTenderhubShowreel | null;
};

function getVideoMimeType(
  fileUrl?: string,
  fileName?: string
): string | undefined {
  const val = `${fileName ?? ""} ${fileUrl ?? ""}`.toLowerCase();
  if (val.includes(".webm")) return "video/webm";
  if (val.includes(".mp4")) return "video/mp4";
  return undefined;
}

export default function TenderhubShowreelSection({ showreel }: Props) {
  const videoUrl = showreel?.video?.url ? getAssetUrl(showreel.video.url) : "";
  const videoType = getVideoMimeType(videoUrl, showreel?.video?.name);
  const presentationUrl = showreel?.presentation?.url
    ? getAssetUrl(showreel.presentation.url)
    : "";

  return (
    <AccordionItemPrimary
      id="showreel"
      title="шоурил и презентация компании"
      unmountOnClose
    >
      {(isOpen) => (
        <>
          {isOpen && videoUrl ? (
            <video
              className="tenderhub-content-list__video"
              controls
              preload="auto"
              playsInline
            >
              <source src={videoUrl} type={videoType} />
            </video>
          ) : null}

          {presentationUrl ? (
            <a
              href={presentationUrl}
              target="_blank"
              rel="noreferrer"
              className="link"
            >
              Презентация компании CREON 2026
            </a>
          ) : null}
        </>
      )}
    </AccordionItemPrimary>
  );
}

